/**
 * SFX identifiers: gameplay + short UI feedback (CDN keys under ASSET_PATHS.SOUNDS).
 */

export const SOUND_IDS = {
  DAILY_CLAIM: 'daily-claim',
  CHALLENGE_WIN: 'challenge-win',
  CHALLENGE_LOST: 'challenge-lost',
  STREAK_MILESTONE: 'streak-milestone',
  /** Snackbar success + non-destructive dialog confirm (debounced in soundStore). */
  UI_SUCCESS: 'ui-success',
  /** Destructive dialog confirm (delete, leave, etc.). */
  UI_DANGER_COMMIT: 'ui-danger-commit',
  /** Snackbar / toast: error */
  UI_ERROR: 'ui-error',
  /** Snackbar / toast: warning */
  UI_WARNING: 'ui-warning',
  /** Snackbar / toast: info */
  UI_INFO: 'ui-info',
  /** Dialog cancel, backdrop dismiss, close without confirm */
  UI_DISMISS: 'ui-dismiss',
  /** Generic control tap (tabs, FAB, menu rows, etc.). */
  UI_TAP: 'ui-tap',
  /** Create flow / match details: Back, Next, primary step navigation. */
  UI_TAP_NAV: 'ui-tap-nav',
  /** Odds / market cell selection (1X2, O/U, handicap, delete market pick). */
  UI_TAP_PICK: 'ui-tap-pick',
  /** Stake stepper, coin display tap (economy / entry amount). */
  UI_TAP_STAKE: 'ui-tap-stake',
  /** Friends & groups: cards, filters, Friends|Groups toggle. */
  UI_TAP_SOCIAL: 'ui-tap-social',
  /** Section / card / league header opening (bundled MP3). */
  UI_SECTION_EXPAND: 'ui-section-expand',
  /** Section / card / league header closing (bundled MP3). */
  UI_SECTION_COLLAPSE: 'ui-section-collapse',
  /** App global hamburger menu drawer opening (bundled MP3). */
  UI_MENU_OPEN_SWISH: 'ui-menu-open-swish',
  /** Ticket-stub tear-off animation (bundled MP3). */
  UI_PAPER_TEAR: 'ui-paper-tear',
  /** Level-up toast chime (bundled MP3, generated from the celebration design synth). */
  LEVEL_UP: 'level-up',
  /** Rank-up Badge Forge sequence: riser → impact at ~0.95s → arpeggio → chord (bundled MP3). */
  RANK_UP: 'rank-up',
} as const;

export type SoundId = (typeof SOUND_IDS)[keyof typeof SOUND_IDS];

/** Avoid double-ding when a dialog confirm is immediately followed by a success snackbar. */
export const UI_SUCCESS_SOUND_DEBOUNCE_MS = 450;

/** Per-variant debounce for error / warning / info snackbars (rapid repeats). */
export const UI_SNACKBAR_VARIANT_DEBOUNCE_MS = 220;

/** Debounce for generic button / tab tap SFX (rapid taps). */
export const UI_TAP_SOUND_DEBOUNCE_MS = 85;

/** Matches `SnackbarVariant` in snackbarStore (avoid circular import). */
export type SnackbarSoundVariant = 'success' | 'error' | 'info' | 'warning';
